import React from 'react';
import { Checkbox } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { setShowSocialCompanies } from 'reducers/Watchlist';

const SocialCheckboxRenderer = () => {
  const dispatch = useDispatch();
  const showSocialCompanies = useSelector(state => state.Watchlist.showSocialCompanies);
  return (
    <Checkbox
      checked={showSocialCompanies}
      onChange={event => dispatch(setShowSocialCompanies(event.target.checked))}
      color="primary"
      inputProps={{ 'aria-label': 'primary checkbox' }}
      style={{ padding: 0 }}
    />
  );
};

export default SocialCheckboxRenderer;
